import { useRouter } from "next/router";
import { useEffect } from "react";

import Layout from "../components/layouts/layout.comp";
import { useTranslation } from "../core/translation.core";

export default function IndexPage() {
  const { t, msg } = useTranslation();

  // const { push } = useRouter();
  // useEffect(() => {
  //   push("/products");
  // }, [push]);

  return (
    <Layout title={t(msg.index.dashboard)}>
      <section data-type="section"></section>
    </Layout>
  );
}
